module.exports = __webpack_public_path__ + "static/img/status_indication04.a0c0d7d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/status_indication04.gif
// module id = yCM9
// module chunks = 1